const sidenavItems = [
  {
    name: "Rendez-vous",
    path: "/rdvs",
    icon: "calendar-alt",
    dataPriv: "manager_appointments",
  },
  {
    name: "Rechercher un allocataire",
    path: "/all-recipients",
    icon: "search",
    dataPriv: "view_recipients",
  },
  {
    name: "Allocataires",
    path: "/recipients",
    icon: "users",
    dataPriv: "view_recipients",
  },
  {
    name: "Allocataires temporaires",
    path: "/recipients-temp",
    icon: "user-clock",
    dataPriv: "view_recipients_temp",
  },
  {
    name: "Allocataires stock",
    path: "/recipients-stock",
    icon: "archive",
    dataPriv: "view_recipients_temp",
  },
  // {
  //   name: "Allocataires passés en EP",
  //   path: "/recipients-ep-results",
  //   icon: "users",
  //   dataPriv: "view_recipients_temp",
  // },

  {
    name: "Statistiques",
    path: "/stats",
    icon: "chart-bar",
    dataPriv: "view_stats",
  },
  {
    name: "Réorientations en cours",
    path: "/reorientations",
    icon: "map-signs",
    dataPriv: "crud_reorientations",
  },

  {
    name: "Entités globales",
    path: "#",
    icon: "sitemap",
    items: [
      {
        name: "Utilisateurs",
        path: "/users",
        icon: "user",
        dataPriv: "crud_users",
      },
      {
        name: "Organisations",
        path: "/organizations",
        icon: "sitemap",
        dataPriv: "crud_organizations",
      },
      {
        name: "Sites / Calendriers",
        path: "/sites",
        icon: "map-marker-alt",
        dataPriv: "view_sites",
      },
    ],
  },
  {
    name: "Anomalies",
    path: "#",
    icon: "exclamation-triangle",
    items: [
      {
        name: "Anomalies",
        path: "/anomalies",
        icon: "exclamation-triangle",
        dataPriv: "view_anomalies",
      },
      {
        name: "Mes anomalies",
        path: "/my-anomalies",
        icon: "user-check",
        dataPriv: "manage_anomalies",
      },
      {
        name: "Suivi BRSA SDD sans RDO ou sans RDV EG",
        path: "/suivi-anomalies",
        icon: "user-clock",
        dataPriv: "manage_anomalies",
      },
      {
        name: "Jobs échoués",
        path: "/anomalies-orientation-ft",
        icon: "bug",
        dataPriv: "view_anomalies",
      },
    ],
  },
  {
    name: "Opérateurs",
    path: "#",
    icon: "hands-helping",
    items: [
      {
        name: "Répertoire des opérateurs",
        path: "/operateurs",
        icon: "address-book",
        dataPriv: "crud_operateurs",
      },
      {
        name: "Opérateurs d'accompagnement",
        path: "/operateurs/accompagnement",
        icon: "building",
        dataPriv: "crud_operateurs",
      },
      {
        name: "Règles de sous-orientation",
        path: "/operateurs/regles-sous-orientation",
        icon: "list-ol",
        dataPriv: "view_regles_orientation",
      },
      {
        name: "Activités opérateur",
        path: "/themes",
        icon: "atom",
        dataPriv: "crud_themes",
      },
    ],
  },

  {
    name: "CER",
    path: "#",
    icon: "file-signature",
    items: [
      {
        name: "Données CER",
        path: "/cer-data",
        icon: "cog",
        dataPriv: "modify_constants",
      },
      {
        name: "Liste des CER",
        path: "/cer-list",
        icon: "signature",
        dataPriv: "view_cer_list",
      },
    ],
  },

  {
    name: "EP",
    path: "#",
    icon: "users-cog",
    items: [
      {
        name: "Secteurs EP",
        path: "/sectors",
        icon: "compass",
        dataPriv: "view_sectors",
      },
      {
        name: "Calendrier des EP",
        path: "/ep",
        icon: "street-view",
        dataPriv: "view_ep_calendar",
        isEP: true,
      },
      {
        name: "Mes invitations aux EP",
        path: "/myeps",
        icon: "reply",
        dataPriv: "view_ep_calendar",
        isEP: true,
      },
      {
        name: "Gestion des invitations EP",
        path: "/allepinvitations",
        icon: "paper-plane",
        dataPriv: "manage_ep_invitations",
      },
      {
        name: "Sanctions France Travail",
        path: "/sanctions-france-travail",
        icon: "gavel",
        dataPriv: "view_sanctions_ft",
      },
      {
        name: "Suspension / Remobilisation",
        path: "/suspension-remobilisation",
        icon: "unlock-alt",
        // Réservé au Directeur de la Caf et à ses délégataires (isDirector).
        directorOnly: true,
      },
      // {
      //   name: "Allocataires EP",
      //   path: "/recipients-ep",
      //   icon: "user-tag",
      //   dataPriv: "create_recipient_ep",
      // },
    ],
  },
  {
    name: "Outils",
    path: "#",
    icon: "tools",
    items: [
      {
        name: "Paramètres",
        path: "/dynamic-constants",
        icon: "cog",
        dataPriv: "modify_constants",
      },
      {
        name: "Simulateur",
        path: "/simulator",
        icon: "calculator",
        dataPriv: "use_simulator",
      },
      {
        name: "Fichiers d'échange",
        path: "/file-exchange",
        icon: "exchange-alt",
        dataPriv: "file_exchange",
      },
      {
        name: "Invitation RDO",
        path: "/invite-rdo",
        icon: "envelope",
        dataPriv: "file_exchange",
      },
      {
        name: "Suivi des imports",
        path: "/imports",
        icon: "file-import",
        dataPriv: "view_imports",
      },
      {
        name: "Suivi des exports",
        path: "/exports",
        icon: "file-export",
        dataPriv: "view_exports",
      },
    ],
  },
];

// Menu d'un compte d'opérateur d'accompagnement (CE-1407) : sa structure et
// ses sites, rien d'autre. Sans `dataPriv` : le périmètre est porté par le
// rôle (visibiliteMenu.filtrerMenu), pas par un privilège.
export const MENU_OPERATEUR = [
  {
    name: "Ma structure",
    path: "/ma-structure",
    icon: "building",
  },
  {
    name: "Sites et calendriers",
    path: "/ma-structure/sites",
    icon: "map-marker-alt",
  },
];

export default sidenavItems;
